import { useState } from "react"
import { Button } from "dash-styled"

import { PartialBy } from "../../../../../../../../../Models/Utility/PartialBy"
import {
    VisualEditor as VisualEditorIsolated,
    VisualEditorProps
} from "../../../../../../../../Common/SchemaForm/DocumentsExtraction/VisualEditor"
import { SimpleEditor } from "../../../../../../../../Common/SchemaForm/DocumentsExtraction/SimpleEditor"
import { DocumentsExtractionChildProps } from "../../../../../../../../Common/SchemaForm/DocumentsExtraction"
import { DocumentSelector } from "./DocumentSelector"

export type ExtraSettingsProps = { appID: string; noSave: boolean }

const VisualEditor = ({
    input,
    ...props
}: PartialBy<VisualEditorProps, "input">) =>
    input ? <VisualEditorIsolated {...props} input={input} /> : null

export const DocumentsExtractionSettings = ({
    appID,
    submitting,
    noSave,
    onForward,
    onBack,
    onChange,
    onSubmit,
    selectedDocument,
    input,
    output,
    errors,
    visualEditor,
    parameterSchema
}: DocumentsExtractionChildProps<ExtraSettingsProps>) => {
    const [documentUrl, setSelectedDocument] = selectedDocument
    const [isVisualEditor, openVisualEditor, closeVisualEditor] = visualEditor

    const [selectedJobID, setSelectedJobID] = useState<string>()

    const removeSelectedDocument = () => {
        setSelectedDocument(undefined)
        setSelectedJobID(undefined)
    }

    return (
        <>
            {isVisualEditor ? (
                !documentUrl ? (
                    <DocumentSelector
                        appID={appID}
                        selectedJobID={selectedJobID}
                        setSelectedJobID={setSelectedJobID}
                        setSelectedDocument={setSelectedDocument}
                    />
                ) : (
                    <VisualEditor
                        settings
                        input={input}
                        output={{
                            ...output,
                            onChange
                        }}
                        parameterSchema={parameterSchema}
                        errors={errors}
                        onForward={
                            noSave || submitting || errors
                                ? undefined
                                : onForward
                        }
                        onBack={removeSelectedDocument}
                        closeVisualEditor={closeVisualEditor}
                    />
                )
            ) : (
                <div className="w-full flex flex-col items-center pb-6">
                    <SimpleEditor
                        settings
                        output={{
                            ...output,
                            onChange
                        }}
                        parameterSchema={parameterSchema}
                        errors={errors}
                        openVisualEditor={openVisualEditor}
                    />
                    <Button
                        color="darkviolet"
                        variant="contained"
                        onClick={onSubmit}
                        disabled={noSave || submitting}
                        testId="apply-parameters"
                        className="w-auto px-12"
                    >
                        {submitting ? "Saving..." : "Save changes"}
                    </Button>
                </div>
            )}
        </>
    )
}
